import { api } from '../../utils';

class ModuleApi {
  getProfiles() {
    return api.get('/profiles/temperature');
  }

  getBuilds(id) {
    return api.get(`/buildings/${id}`);
  }

  addBuild(data) {
    return api.post('/buildings', data);
  }

  editBuild(id, data) {
    return api.put(`/buildings/${id}`, data);
  }

  patchBuildEUI(id, eui) {
    return api.patchBuildings(id, { eui });
  }

  deleteBuild(id) {
    return api.delete(`/buildings/${id}`);
  }

  getSites() {
    return api.get('/sites');
  }

  addSite(data) {
    return api.post('/sites', data);
  }

  editSite(id, data) {
    return api.put(`/sites/${id}`, data);
  }

  deleteSite(id) {
    return api.delete(`/sites/${id}`);
  }

  getRoomsByLevelId(levelId) {
    return api.get(`rooms/level/${levelId}`);
  }

  getSubtenants() {
    return api.get('/subtenants/joined');
  }

  getLevels(id) {
    return api.get(`levels/${id}`);
  }

  addLevel(data) {
    return api.post('levels', data);
  }

  deleteLevel(id) {
    return api.delete(`levels/${id}`);
  }

  editLevel(id, data) {
    return api.put(`levels/${id}`, data);
  }

  addRoom(data) {
    return api.post('rooms', data);
  }

  editRoom(id, data) {
    return api.put(`rooms/${id}`, data);
  }

  patchRoomSize(id, size) {
    return api.patchRooms(id, { size });
  }

  deleteRoom(id) {
    return api.delete(`rooms/${id}`);
  }
}

export default new ModuleApi();
